// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"c47562615495c21b","9777":"332db7d3b89b8ead"}[chunkId] + ".js";
};